import React, { Component } from "react";
import { dateConvert } from "../../common/Helpers";
import { Localization } from "../../common/Localization";
import LoadingPanel from "../../common/LoadingPanel";
import { registerForLocalization, provideLocalizationService } from "@progress/kendo-react-intl";
import { Button, DropDownButton, DropDownButtonItem } from "@progress/kendo-react-buttons";
import { Input } from "@progress/kendo-react-inputs";
import BalikArtikleDialogContent from "../../dialogs/BalikArtikleDialogContent";
import VlnyDialogContent from "../../dialogs/VlnyDialogContent";
import KartyTagyDialogContent from "../../dialogs/KartyTagyDialogContent";
import PaletaDialogContent from "../../dialogs/PaletaDialogContent";
import ExpedovatDialogContent from "../../dialogs/ExpedovatDialogContent";
import { homeController } from "../../../controllers/home.controller";
import { sestavyController } from "../../../controllers/sestavy.controller";
import DialogWindow from "../../common/DialogWindow";
import PdfViewer from "../../common/PdfViewer";

// Import the Grid component.
import BalikyGrid from "./BalikyGrid";
import { MessageTypeEnum, ButtonGroupEnum, ButtonMessageEnum, LogLevel } from "../../../enums";
import { balikArtikleController } from "../../../controllers/balikartikle.controller";
import confirmService from "../../common/confirmService";
import { logController } from "../../../controllers/log.controller";

class OdoslanieNeexpedovaneBalikyPalety extends Component {
    novyBalikRunning = false;

    state = {
        items: [],
        loadedItems: [],
        selectedBalikIds: [],
        loading: true,
        dialog: {
            title: null,
            content: null,
            width: null,
            height: null
        },
        pdfShow: false,
        pdfLoading: false,
        pdfPrint: true,
        pdfFile: null,
        confirmDialog: {
            show: false,
            content: null
        },
        novyBalikDisabled: false,
        balikyGridFilter: "",
        balikyGridFilterActive: false
    };

    componentDidMount() {
        this.reloadGrid();
    }

    shouldComponentUpdate(nextProps) {
        if (nextProps.shouldReloadGrid && this.props.shouldReloadGrid !== nextProps.shouldReloadGrid) {
            this.reloadGrid();
        }
        return true;
    }

    reloadGrid = (handleReloaded) => {
        this.setState({ selectedBalikIds: [], loading: true });
        homeController
            .getOdoslanieNeexpedovaneBalikyPalety()
            .then((ajaxData) => {
                let data = JSON.parse(JSON.stringify(ajaxData), dateConvert);
                if (!data.isError) {
                    var loadedItems = data.map((item) => ({ ...item, selected: false }));
                    this.setState({ items: loadedItems, loadedItems: loadedItems, loading: false, balikyGridFilter: "", balikyGridFilterActive: false });
                    this.props.afterReload();
                    if (handleReloaded) {
                        handleReloaded();
                    }
                } else {
                    logController.logMessage("OdoslanieNeexpedovaneBalikyPalety.reloadGrid: " + data.errorMessage, LogLevel.Error);
                    this.setState({
                        errorMessage:
                            "Server vrátil chybu pri načítaní zoznamu. Chyba bola zaznamenaná do logu.\n\nSkúste prosím načítať zoznam znova pomocou tlačidla Aktualizovať.",
                        loading: false
                    });
                }
            })
            .catch((error) => {
                logController.logMessage("OdoslanieNeexpedovaneBalikyPalety.reloadGrid: " + error, LogLevel.Error);
                this.setState({
                    errorMessage:
                        "Server vrátil chybu pri načítaní zoznamu. Chyba bola zaznamenaná do logu.\n\nSkúste prosím načítať zoznam znova pomocou tlačidla Aktualizovať.",
                    loading: false
                });
            });
    };

    scrollToSelected() {
        var divBalikyPalety = document.getElementById("OdoslanieNeexpedovaneBalikyPalety");
        if (divBalikyPalety) {
            var container = divBalikyPalety.getElementsByClassName("k-virtual-content");
            if (container) {
                var selectedElement = container[0].getElementsByClassName("k-state-selected");
                if (selectedElement) selectedElement[0].scrollIntoView({ behavior: "smooth", block: "end" });
            }
        }
    }

    printPaletaList = (paletaId) => {
        this.setState({
            pdfShow: true,
            pdfLoading: true
        });

        sestavyController.GetPaletovyList(paletaId, (fileURL) => {
            this.setState({
                pdfLoading: false,
                pdfPrint: true,
                pdfFile: fileURL
            });
        });
    };

    printBalikStitek = (balikId) => {
        this.setState({
            pdfShow: true,
            pdfLoading: true
        });

        sestavyController.GetBalikStitek(balikId, (fileURL) => {
            this.setState({
                pdfLoading: false,
                pdfPrint: true,
                pdfFile: fileURL
            });
        });
    };

    selectSavedBalikPaleta = (balikId) => {
        var items = this.state.items;
        items.forEach((item) => (item.selected = item.idbalik == balikId));
        this.setState({
            selectedBalikIds: [balikId],
            items: items
        });
        this.scrollToSelected();
    };

    printPotvrdeniePreVodica = (idExpedicia) => {
        this.setState({
            pdfShow: true,
            pdfLoading: true
        });
        sestavyController.GetPotvrzeniProRidice(idExpedicia, false, (fileURL) => {
            this.setState({
                pdfLoading: false,
                pdfPrint: true,
                pdfFile: fileURL
            });
        });
    };

    printGlsExpediciaStitky = (idExpedicia, printPosition) => {
        var localizationService = provideLocalizationService(this);

        this.setState({
            pdfShow: true,
            pdfLoading: true
        });

        sestavyController.GetGlsExpediciaStitky(
            idExpedicia,
            printPosition,
            (fileURL) => {
                this.setState({
                    pdfLoading: false,
                    pdfPrint: true,
                    pdfFile: fileURL
                });
            },
            async (errorMessage) => {
                this.setState({
                    pdfLoading: false,
                    pdfShow: false,
                    pdfPrint: false,
                    pdfFile: null
                });
                await confirmService.show({
                    type: MessageTypeEnum.CRITICAL,
                    message:
                        localizationService.toLanguageString("OdoslanieBaliky.Chyba při generování GLS štítku.", "Chyba při generování GLS štítku.") +
                        "\n\n" +
                        errorMessage
                });
            }
        );
    };

    changeSelectedBalikPaleta = (balikIds) => {
        this.setState({
            selectedBalikIds: balikIds
        });
    };

    async handleMoznostiItemClick(event) {
        var localizationService = provideLocalizationService(this);

        switch (event.itemIndex) {
            case 0: // Upraviť neexpedovaný balík
                if (this.state.selectedBalikIds.length != 1) {
                    await confirmService.show({
                        type: MessageTypeEnum.EXCLAMATION,
                        message: localizationService.toLanguageString(
                            "BalíkFRM.Zo zoznamu neexpedovaných balíkov vyberte jeden balík, ktorý chcete upraviť !",
                            "Zo zoznamu neexpedovaných balíkov vyberte jeden balík, ktorý chcete upraviť !"
                        )
                    });
                } else if (this.state.selectedBalikIds[0] >= 300000000) {
                    await confirmService.show({
                        message: localizationService.toLanguageString(
                            "BalíkFRM.Zo zoznamu vyberte balík, nie paletu !",
                            "Zo zoznamu vyberte balík, nie paletu !"
                        )
                    });
                } else {
                    this.openBalikArtikleDialog(
                        localizationService.toLanguageString("BalíkFRM.Úprava balíka", "Úprava balíka"),
                        this.state.selectedBalikIds[0]
                    );
                }
                break;
            case 1: // Odstranit neexpedovaný balík
                if (this.state.selectedBalikIds.length != 1) {
                    await confirmService.show({
                        type: MessageTypeEnum.EXCLAMATION,
                        message: localizationService.toLanguageString(
                            "BalíkFRM.Zo zoznamu neexpedovaných balíkov vyberte jeden balík, ktorý chcete upraviť !",
                            "Zo zoznamu neexpedovaných balíkov vyberte jeden balík, ktorý chcete upraviť !"
                        )
                    });
                } else if (this.state.selectedBalikIds[0] >= 300000000) {
                    await confirmService.show({
                        message: localizationService.toLanguageString(
                            "BalíkFRM.Zo zoznamu vyberte balík, nie paletu !",
                            "Zo zoznamu vyberte balík, nie paletu !"
                        )
                    });
                } else {
                    this.deleteBalik(this.state.selectedBalikIds[0]);
                }
                break;
            case 2: // Upraviť/Odstrániť neexpedovanú paletu
                if (this.state.selectedBalikIds.length != 1) {
                    await confirmService.show({
                        message: localizationService.toLanguageString(
                            "PaletyFRM.Vyberte jednu paletu, ktorú chcete upraviť !",
                            "Vyberte jednu paletu, ktorú chcete upraviť !"
                        )
                    });
                } else if (this.state.selectedBalikIds[0] < 300000000) {
                    await confirmService.show({
                        message: localizationService.toLanguageString(
                            "PaletyFRM.Vyberte jednu paletu (nie balík), ktorú chcete upraviť !",
                            "Vyberte jednu paletu (nie balík), ktorú chcete upraviť !"
                        )
                    });
                } else {
                    this.openPaletaDialog(
                        localizationService.toLanguageString("PaletyFRM.Úprava balíkov na palete", "Úprava balíkov na palete"),
                        this.state.selectedBalikIds[0]
                    );
                }
                break;
            case 3: // Vytlačiť paletový list
                if (this.state.selectedBalikIds.length != 1) {
                    await confirmService.show({
                        message: localizationService.toLanguageString(
                            "PaletyFRM.Vyberte jednu paletu, pre ktorú chcete tlačiť paletový list !",
                            "Vyberte jednu paletu, pre ktorú chcete tlačiť paletový list !"
                        )
                    });
                } else if (this.state.selectedBalikIds[0] < 300000000) {
                    await confirmService.show({
                        message: localizationService.toLanguageString(
                            "PaletyFRM.Vyberte jednu paletu, pre ktorú chcete tlačiť paletový list !",
                            "Vyberte jednu paletu, pre ktorú chcete tlačiť paletový list !"
                        )
                    });
                } else {
                    this.printPaletaList(this.state.selectedBalikIds[0]);
                }
                break;
            case 4: // Označiť všetky balíky
                this.setState({ items: this.state.items.map((item) => ({ ...item, selected: true })) });
                break;
            case 5: // Vlny vratného tovaru
                this.setState({
                    dialog: {
                        title: localizationService.toLanguageString("MenuFRM.Vlny vráteného tovaru", "Vlny vráteného tovaru"),
                        content: () => <VlnyDialogContent />,
                        height: "90%",
                        width: "90%"
                    }
                });
                break;
            case 6: // Tagy artiklov
                this.setState({
                    dialog: {
                        title: localizationService.toLanguageString("MenuFRM.Tagy artiklov", "Tagy artiklov"),
                        content: () => <KartyTagyDialogContent switchKeyboardEventHandler={this.props.switchKeyboardEventHandler} />,
                        height: "90%",
                        width: "90%"
                    }
                });
                break;
        }
    }

    deleteBalik = async (idBalik) => {
        balikArtikleController.ValidateDeletedBalik(idBalik).then(async (response) => {
            if (response.errorMessage) {
                await confirmService.show({
                    type: response.messageType,
                    message: response.errorMessage
                });
            } else {
                const confirmResult = await confirmService.show({
                    type: MessageTypeEnum.QUESTION,
                    message: response.confirmMessage,
                    buttons: ButtonGroupEnum.YES_NO
                });
                if (confirmResult == ButtonMessageEnum.YES) {
                    await this.deleteBalikUplne(response.idBalik);
                }
            }
        });
    };

    deleteBalikUplne = async (idBalik) => {
        balikArtikleController.DeleteBalik(idBalik).then(async (response) => {
            if (response.errorMessage) {
                await confirmService.show({
                    type: MessageTypeEnum.CRITICAL,
                    message: response.errorMessage
                });
            } else {
                this.reloadGrid();
                this.props.reloadSpravyGrid();
            }
        });
    };

    handleExpedovat = async () => {
        var localizationService = provideLocalizationService(this);
        if (this.state.selectedBalikIds.length == 0) {
            await confirmService.show({
                message: localizationService.toLanguageString(
                    "ExpedíciaFRM.V zozname neexpedovaných balíkov označte balíky alebo palety, ktoré chcete expedovať !",
                    "V zozname neexpedovaných balíkov označte balíky alebo palety, ktoré chcete expedovať !"
                )
            });
        } else {
            this.openExpedovatDialog();
        }
    };

    handleNovyBalik = () => {
        if (this.novyBalikRunning) {
            return;
        }
        this.novyBalikRunning = true;
        this.setState({ novyBalikDisabled: true }, () => {
            var localizationService = provideLocalizationService(this);
            this.openBalikArtikleDialog(localizationService.toLanguageString("BalíkFRM.Nový balík", "Nový balík"), 0);
        });
    };

    handleNovaPaleta = () => {
        var localizationService = provideLocalizationService(this);
        this.openPaletaDialog(localizationService.toLanguageString("PaletyFRM.Nová paleta - výber balíkov", "Nová paleta - výber balíkov"), 0);
    };

    handleFiltrFocus = () => {
        this.props.switchKeyboardEventHandler(true);
    };

    handleFiltrBlur = () => {
        this.props.switchKeyboardEventHandler(false);
    };

    handleFiltrChange = (e) => {
        this.setState({
            balikyGridFilter: e.value
        });
    };

    handleFiltrKeyPress = (e) => {
        if (e.key == "Enter") {
            this.handleFiltrClick();
        }
    };

    handleFiltrClick = () => {
        if (this.state.balikyGridFilterActive || this.state.balikyGridFilter == "") {
            // filtr byl aktivní, tak vypnout
            this.setState({
                items: this.state.loadedItems,
                balikyGridFilter: "",
                balikyGridFilterActive: false
            });
        } else {
            var gridFilter = this.state.balikyGridFilter.toLowerCase();

            // filtr nebyl aktivní, tak zapnout
            this.setState({
                items: this.state.loadedItems.filter(function (item) {
                    return (
                        item.ciarovyKod.includes(gridFilter) ||
                        item.skladToNazov.toLowerCase().includes(gridFilter) ||
                        item.zoznamTypTovaru.toLowerCase().includes(gridFilter)
                    );
                }),
                balikyGridFilterActive: true
            });
        }
    };

    openBalikArtikleDialog(title, idBalik) {
        this.props.switchKeyboardEventHandler(true);

        this.setState(
            {
                dialog: {
                    title: title,
                    hasClosingConfirmDialog: true,
                    content: (onClose, showClosingConfirmDialog, allowOpeningConfirmDialog, toggleErrorDialog, closeConfirmDialog) => (
                        <BalikArtikleDialogContent
                            idBalik={idBalik}
                            toggleDialog={onClose}
                            reloadGrid={(handleReloaded) => {
                                this.reloadGrid(handleReloaded);
                                this.props.reloadSpravyGrid();
                            }}
                            printBalikStitek={this.printBalikStitek}
                            selectSavedBalikPaleta={this.selectSavedBalikPaleta}
                            showClosingConfirmDialog={showClosingConfirmDialog}
                            balikIsChanged={allowOpeningConfirmDialog}
                            showErrorDialog={toggleErrorDialog}
                            closeConfirmDialog={closeConfirmDialog}
                            switchKeyboardEventHandler={this.props.switchKeyboardEventHandler}
                        />
                    ),
                    height: "740px",
                    width: "722px",
                    extraClosingCallback: () => {
                        this.props.switchKeyboardEventHandler(false);
                    }
                }
            },
            () => {
                this.novyBalikRunning = false;
                this.setState({ novyBalikDisabled: false });
            }
        );
    }

    openPaletaDialog(title, idPaleta) {
        this.setState({
            dialog: {
                title: title,
                content: (onClose) => (
                    <PaletaDialogContent
                        idPaleta={idPaleta}
                        toggleDialog={onClose}
                        reloadGrid={(handleReloaded) => {
                            this.reloadGrid(handleReloaded);
                            this.props.reloadSpravyGrid();
                        }}
                        printPaletaList={this.printPaletaList}
                        selectSavedBalikPaleta={this.selectSavedBalikPaleta}
                    />
                ),
                height: "90%",
                width: "90%"
            }
        });
    }

    openExpedovatDialog() {
        var localizationService = provideLocalizationService(this);
        this.setState({
            dialog: {
                title: localizationService.toLanguageString("ExpedíciaFRM.Expedícia", "Expedícia"),
                content: (onClose) => (
                    <ExpedovatDialogContent
                        selectedBalikIds={this.state.selectedBalikIds}
                        toggleDialog={onClose}
                        reloadGrid={(handleReloaded) => {
                            this.reloadGrid(handleReloaded);
                            this.props.reloadSpravyGrid();
                        }}
                        printPotvrdeniePreVodica={this.printPotvrdeniePreVodica}
                        printGlsExpediciaStitky={this.printGlsExpediciaStitky}
                        switchKeyboardEventHandler={this.props.switchKeyboardEventHandler}
                    />
                ),
                height: "400px",
                width: "500px",
                extraClosingCallback: () => {
                    this.props.switchKeyboardEventHandler(false);
                }
            }
        });
    }

    renderTable(items) {
        var localizationService = provideLocalizationService(this);

        return (
            <div id="OdoslanieNeexpedovaneBalikyPalety">
                <h2 className="row">
                    <div className="col-xs-6">
                        <Localization messageKey={"MenuFRM.NEEXPEDOVANÉ"} defaultMessage={"NEEXPEDOVANÉ"} /> ({items.length})
                    </div>
                    <div className="col-xs-6">
                        <div className="pull-right">
                            <Input
                                value={this.state.balikyGridFilter}
                                placeholder="Zadejte filtr..."
                                onFocus={this.handleFiltrFocus}
                                onBlur={this.handleFiltrBlur}
                                onChange={this.handleFiltrChange}
                                onKeyPress={this.handleFiltrKeyPress}
                            />
                            <Button
                                icon={this.state.balikyGridFilterActive ? "filter-clear" : "filter"}
                                title="Filtrovat"
                                disabled={this.state.balikyGridFilter == ""}
                                onClick={this.handleFiltrClick}
                            />
                        </div>
                    </div>
                </h2>
                <BalikyGrid items={items} pageable={false} changeSelectedBalikPaleta={this.changeSelectedBalikPaleta} multiselect={true} />
                <div className="grid-button-bar">
                    <div className="col-sm-6">
                        <Button icon="check" onClick={this.handleExpedovat}>
                            <Localization messageKey={"MenuFRM.Expedovať"} defaultMessage={"Expedovať"} />
                        </Button>{" "}
                        <DropDownButton
                            text={localizationService.toLanguageString("MenuFRM.Možnosti", "Možnosti")}
                            icon="menu"
                            onItemClick={(e) => this.handleMoznostiItemClick(e)}>
                            <DropDownButtonItem
                                text={localizationService.toLanguageString("MenuFRM.Upraviť neexpedovaný balík", "Upraviť neexpedovaný balík")}
                            />
                            <DropDownButtonItem
                                text={localizationService.toLanguageString("MenuFRM.Odstrániť neexpedovaný balík", "Odstrániť neexpedovaný balík")}
                            />
                            <DropDownButtonItem
                                text={localizationService.toLanguageString(
                                    "MenuFRM.Upraviť/Odstrániť neexpedovanú paletu",
                                    "Upraviť/Odstrániť neexpedovanú paletu"
                                )}
                            />
                            <DropDownButtonItem text={localizationService.toLanguageString("MenuFRM.Vytlačiť paletový list", "Vytlačiť paletový list")} />
                            <DropDownButtonItem text={localizationService.toLanguageString("MenuFRM.Označiť všetky balíky", "Označiť všetky balíky")} />
                            <DropDownButtonItem text={localizationService.toLanguageString("MenuFRM.Vlny vráteného tovaru", "Vlny vráteného tovaru")} />
                            <DropDownButtonItem text={localizationService.toLanguageString("MenuFRM.Tagy artiklov", "Tagy artiklov")} />
                        </DropDownButton>
                    </div>
                    <div className="col-sm-6 text-right">
                        <Button icon="plus" className="font-bold" onClick={this.handleNovaPaleta}>
                            <Localization messageKey={"MenuFRM.Nová paleta"} defaultMessage={"Nová paleta"} />
                        </Button>{" "}
                        <Button icon="plus" className="font-bold" onClick={this.handleNovyBalik} disabled={this.state.novyBalikDisabled}>
                            <Localization messageKey={"MenuFRM.Nový balík"} defaultMessage={"Nový balík"} />
                        </Button>
                    </div>
                </div>
                <div id="PrijemSkenerMessage" className="alert alert-warning">
                    <Localization
                        messageKey={"MenuFRM.Príjem tovaru začnite naskenovaním čiarového kódu balíka"}
                        defaultMessage={"Príjem tovaru začnite naskenovaním čiarového kódu balíka"}
                    />
                </div>
            </div>
        );
    }

    renderError(errorMessage) {
        return (
            <div id="NahlasenieNenahlaseneDodavky">
                <h2>
                    <Localization messageKey={"MenuFRM.NEEXPEDOVANÉ"} defaultMessage={"NEEXPEDOVANÉ"} />
                </h2>
                <div className="alert alert-danger">{errorMessage}</div>
            </div>
        );
    }

    render() {
        let contents = this.state.loading ? (
            <LoadingPanel />
        ) : this.state.errorMessage ? (
            this.renderError(this.state.errorMessage)
        ) : (
            this.renderTable(this.state.items)
        );

        return (
            <div>
                {contents}
                <DialogWindow dialog={this.state.dialog} />
                <PdfViewer show={this.state.pdfShow} loading={this.state.pdfLoading} print={this.state.pdfPrint} pdfFile={this.state.pdfFile} />
                {this.state.confirmDialog.show && this.state.confirmDialog.content}
            </div>
        );
    }
}

export default OdoslanieNeexpedovaneBalikyPalety;

registerForLocalization(OdoslanieNeexpedovaneBalikyPalety);



// WEBPACK FOOTER //
// ./src/components/views/Home/OdoslanieNeexpedovaneBalikyPalety.js